const projects = [
  {
    name: "Nomad Jobs",
    description:
      "My first real project, I was working on the front-end part. A web page for searching jobs in Bulgaria, with or without creating user profile. There are also blogs, videos and details for every company.",
    tags: [
      {
        name: "nextjs",
      },
      {
        name: "sass",
      },
      {
        name: "typescript",
      },
    ],
    image: "/nomad.webp",
    source_code_link: "",
    live_page: "https://www.nomadjobs.kg/",
  },
  {
    name: "Cinesphere",
    description:
      "Cinesphere is a Vue.js web app with a Node.js/PostgreSQL backend, letting users browse, search, and favorite movies and TV series.",
    tags: [
      {
        name: "vuejs",
      },
      {
        name: "tailwindCSS",
      },
      {
        name: "typescript",
      },
      {
        name: "nodejs",
      },
      {
        name: "postgreSQL",
      },
      {
        name: "express",
      },
    ],
    image: "/cinesphere.webp",
    source_code_link: "https://github.com/Jasminamih/CineSphere",
    live_page: "https://my-cinesphere.netlify.app/",
  },
  {
    name: "Donatello",
    description:
      "Application for 3D ring customization and visualization. This is a long-term project that I worked on the front-end part, integrating the 3D viewer and interface.",
    tags: [
      {
        name: "react",
      },
      {
        name: "sass",
      },
      {
        name: "typescript",
      },
      {
        name: "webgi",
      },
    ],
    image: "/donatello.webp",
  },
  {
    name: "Coin tracker",
    description:
      "An app for tracking your monthly income as well as tracking your monthly expenses with the possibility of setting budget limits. This was the final project on the academy.",
    tags: [
      {
        name: "react",
      },
      {
        name: "materialUI",
      },
      {
        name: "typescript",
      },
    ],
    image: "/coin.webp",
    source_code_link: "https://github.com/Jasminamih/CoinTracker",
    live_page: "https://cointracker-mihajloska.netlify.app/",
  },
  {
    name: "My portfolio",
    description:
      "This is my portfolio. My web page to show my projects and my story. A place where people can contact me for some future projects or work position.",
    tags: [
      {
        name: "nextjs",
      },
      {
        name: "threejs",
      },
      {
        name: "sass",
      },
      {
        name: "typescript",
      },
    ],
    image: "/portfolio.webp",
    live_page: "https://mihajloska.dev/",
  },
  {
    name: "Fit Plan",
    description:
      "Web application for managing workouts, nutrition, and fitness progress for individual users and coaches. Users can log exercises, track meals and macros, and monitor progress toward weight goals.",
    tags: [
      {
        name: "react",
      },
      {
        name: "tailwindcss",
      },
      {
        name: "typescript",
      },
      {
        name: "firebase",
      },
    ],
    image: "/fitplan.webp",
    source_code_link: "https://github.com/Jasminamih/fitness-app",
    live_page: "https://fit-plan.netlify.app/",
  },
];

export default projects;
